import React from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

export default function NewDayReasonInput(props) {
  const { value, setValue } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  function onChangeInput(e) {
		setValue(e.target.value);
  }

  function onFocusInput(e) {
    e.target.style.border = `1px solid ${theme.primary}`;
  }

  function onBlurInput(e) {
    e.target.style.border = `1px solid ${theme.line}`;
  }

  return (
    <TopLevelWrapper>
      <Input
        placeholder={t('memberDetail.extensionModal.extendReasonPlaceholder')}
        value={value || ''}
        onFocus={onFocusInput}
        onChange={onChangeInput}
        onBlur={onBlurInput}/>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const Input = styled.textarea`
  height: 103px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin-top: 8px;
  padding: 8px 12px;

  width: 100%;
  box-sizing: border-box;

  border: 1px solid ${props => props.theme.line};
  border-radius: 6px;
  outline: none;

  color: ${props => props.theme.text};
  background-color: ${props => props.theme.buttonFill};

  resize: none;

  &::placeholder {
    text-align: center;
    line-height: 85px;
    color: ${props => props.theme.subText};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;
